import brandFacebook from '@/assets/images/platform-brand/facebook.png'
import brandInstagram from '@/assets/images/platform-brand/instagram.png'
import brandTiktok from '@/assets/images/platform-brand/tiktok.png'
import brandTwitter from '@/assets/images/platform-brand/twitter.png'
import brandYoutube from '@/assets/images/platform-brand/youtube.png'
import { PlatformShortcode } from '@/utils/convert-platform'

// \b is a word boundary
const SPECIAL_CHAR = ''

enum SupportedPlatform {
  Facebook = PlatformShortcode.Facebook,
  Instagram = PlatformShortcode.Instagram,
  YouTube = PlatformShortcode.YouTube,
  TikTok = PlatformShortcode.TikTok,
  Twitter = PlatformShortcode.Twitter,
}

const SupportedPlatformList = [
  PlatformShortcode.Facebook,
  PlatformShortcode.Instagram,
  PlatformShortcode.YouTube,
  PlatformShortcode.TikTok,
  PlatformShortcode.Twitter,
]

const platformBrandMap: Record<SupportedPlatform, string> = {
  [SupportedPlatform.Instagram]: brandInstagram,
  [SupportedPlatform.Facebook]: brandFacebook,
  [SupportedPlatform.YouTube]: brandYoutube,
  [SupportedPlatform.TikTok]: brandTiktok,
  [SupportedPlatform.Twitter]: brandTwitter,
}

const designLayoutSize = {
  h: 810,
  w: 1440,
}

enum PptxObjectType {
  Text = 'pptx__text',
  Image = 'pptx__image',
  Shape = 'pptx__shape',
}

const chartSize = {
  bar: { h: 340, w: 600 },
  donut: { h: 240, w: 240 },
  stackedColumns: { h: 340, w: 1260 },
  wordCloud: { h: 340, w: 600 },
}

export {
  PptxObjectType,
  SupportedPlatformList,
  platformBrandMap,
  designLayoutSize,
  chartSize,
  SPECIAL_CHAR,
}
